import { request } from "../lib/http";

/**
 * @returns {Promise<Array>}
 */
export function fetchAll() {
  return request({
    url: "contracts",
    method: "get",
  });
}

export function fetchFiltered(params) {
  return request({
    url: "contracts",
    method: "get",
    params,
  });
}

export function fetchByClient(client) {
  return request({
    url: "contracts-by-client",
    method: "get",
    params: {
      client,
    },
  });
}

export function fetchAllContracts(params) {
  return request({
    url: "contracts/all",
    method: "get",
    params,
  });
}

export function add(data) {
  return request({
    url: "financial/contract",
    method: "post",
    data,
  });
}

export function edit(id, data) {
  return request({
    url: `financial/contract/${id}`,
    method: "patch",
    data,
  });
}

export function show(id) {
  return request({
    url: `financial/contract/${id}`,
    method: "get",
  });
}

export function activeContract(id) {
  return request({
    url: `financial/contract/active/${id}`,
    method: "patch",
  });
}

export function inactiveContract(id, data) {
  return request({
    url: `financial/contract/inactive/${id}`,
    method: "patch",
    data,
  });
}

export function blockContract(id) {
  return request({
    url: `financial/contract/block/${id}`,
    method: "patch",
  });
}

export function unblockContract(id, data) {
  return request({
    url: `financial/contract/unblock/${id}`,
    method: "patch",
    data,
  });
}
